// src/StripePaymentForm/PaymentSuccessDialog.jsx
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@material-ui/core';

function PaymentSuccessDialog({ open, onClose, loading, ctaUrl, ctaLabel }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Typography variant="h6" style={{ fontWeight: 600 }}>Payment successful</Typography>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '1rem' }}>
            <CircularProgress />
          </div>
        ) : (
          <>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
              <CheckCircleIcon style={{ fontSize: 44, color: '#22c55e' }} />
            </div>
            <Typography align="center">
              Thank you. Your payment was processed.
            </Typography>
            {ctaUrl && (
              <Typography align="center" variant="body2" style={{ marginTop: 12, color: '#4b5563' }}>
                Activation continues automatically. You can return to your account.
              </Typography>
            )}
          </>
        )}
      </DialogContent>
      {!loading && (
        <DialogActions style={{ justifyContent: 'center' }}>
          {ctaUrl ? (
            <Button
              variant="contained"
              color="primary"
              href={ctaUrl}
            >
              {ctaLabel || 'Back to account'}
            </Button>
          ) : (
            <Button variant="contained" onClick={onClose} color="primary">OK</Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
}

export default PaymentSuccessDialog;
